// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pa_a bhp_sn bhp_sv bhp_sw bhp_kx bhp_ky bhp_ke undefined bhp_vt"};